module.exports = __webpack_public_path__ + "assets/assignment-skill-active.97418308.svg";